// WHIT-494 round 3: the rules behind the cart — whose terms the traveller
// accepts, what still stands between them and the payment options, and what
// the cart's waiting box says. Plain values in and out, so `node --test` can
// load it without a browser.

const { ALLMYLES } = require('./brand');

// The consent labels as [before the link, the link, after the link]
// translation keys. The Hungarian sentence names the brand before the link
// ("Elfogadom a Tipptour …"), so each brand has its own keys around it.
const LEGAL_LABELS = {
  tipptour: {
    terms: ['I accept ', 'the terms and conditions', ' of Tipptour.'],
    privacy: [
      'I agree to the processing of my data as described in ',
      'the Tipptour privacy policy',
      '.',
    ],
  },
  allmyles: {
    terms: [
      'terms_accept_allmyles_before',
      'the terms and conditions',
      'terms_accept_allmyles_after',
    ],
    privacy: [
      'I agree to the processing of my data as described in ',
      'the Allmyles privacy policy',
      '.',
    ],
  },
};

const legalLabels = brand =>
  brand === ALLMYLES ? LEGAL_LABELS.allmyles : LEGAL_LABELS.tipptour;

/**
 * What the traveller still has to do before the payment options open, as
 * translation keys in the order the cart asks for them. Empty when nothing
 * is missing.
 */
const paymentBlockers = ({
  passengersValid,
  invoiceValid,
  termsAccepted,
  privacyAccepted,
}) =>
  [
    [passengersValid, 'payment_blocker_passengers'],
    [invoiceValid, 'payment_blocker_invoice'],
    [termsAccepted, 'payment_blocker_terms'],
    [privacyAccepted, 'payment_blocker_privacy'],
  ]
    .filter(([done]) => !done)
    .map(([, key]) => key);

/**
 * The waiting box's text, or null when there is nothing to wait for. Loading
 * the cart is not a purchase: nothing has been paid at that point, and
 * "processing your purchase" on a cart reopened later read as a payment stuck
 * halfway.
 */
const cartLoaderMessage = ({ loadingFlight, switchingProvider }) => {
  if (loadingFlight) return 'cart_loading';
  if (switchingProvider) return 'cart_preparing_payment';
  return null;
};

/**
 * Whether the cart shows a round trip. The store's trip type falls back to
 * its 'roundtrip' default when the cart is reloaded, so the trip type in the
 * URL decides whenever it holds a known trip type.
 */
const isRoundTripCart = (queryTripType, stateTripType) =>
  (['roundtrip', 'one-way'].includes(queryTripType)
    ? queryTripType
    : stateTripType) === 'roundtrip';

// How long the cart waits for its flight before saying the offer could not
// be loaded. The API's own waits end within about two minutes; a traveller
// looking at a spinner should not have to sit through all of that.
const CART_LOAD_TIMEOUT_MS = 90 * 1000;

module.exports = {
  CART_LOAD_TIMEOUT_MS,
  LEGAL_LABELS,
  legalLabels,
  paymentBlockers,
  cartLoaderMessage,
  isRoundTripCart,
};
